__turbopack_context__.v({
  "blur": "vk0uTq_blur",
  "globalWrapper": "vk0uTq_globalWrapper",
  "imageWrapper": "vk0uTq_imageWrapper",
  "name": "vk0uTq_name",
  "productDescription": "vk0uTq_productDescription",
  "productDetailsWrapper": "vk0uTq_productDetailsWrapper",
  "styledImage": "vk0uTq_styledImage",
  "wrapper": "vk0uTq_wrapper",
});
